import { BsArrowRight, BsArrowUpRightSquare, BsGithub} from "react-icons/bs";
import {IoOpen} from "react-icons/io5"
import { GoPrimitiveDot } from "react-icons/go";

const Github = () => {
  return (
    <div className="bg-primaryC dark:bg-dSecondary dark:text-primaryC">
      <div className="container pb-20">
        <div className="flex justify-between">
          
          <div>
            <h3 className="inline-block px-5 rounded-3xl uppercase bg-secondaryC text-ghC mx-5 my-10 dark:bg-dHeading dark:text-dHeadingC">
              Projects
            </h3>
          </div>

          <div className="flex items-center pr-5">
            <h3 className="pr-2 cursor-pointer text-ghC link link-underline link-underline-black dark:text-dHeadingC">
              <a href="https://github.com/peterjohnson1000" target="_blank">
                Github
              </a>
            </h3>
            <div>
              <BsArrowRight />
            </div>
          </div>

        </div>

        <div className="flex justify-center flex-wrap">
            {/* Project - 1 */}
            <div className="w-72 border-1 p-5 rounded-xl shadow-[rgba(13,_38,_76,_0.19)_0px_9px_20px] mb-10 dark:bg-dPrimary">
              <div className="flex justify-end cursor-pointer">
                {/* <a href="https://github.com/PaulJoshi/Gestify" target="_blank"><BsGithub className="animate-pulse text-xl" /></a> */}
                <a href="https://gestify.netlify.app/" target="_blank" className="flex items-center underline">View <IoOpen className="ml-1"/></a>
              </div>
              
              <div className="flex justify-center py-3 mb-5 rounded-xl">
                <a href="https://gestify.netlify.app/" target="_blank">
                  <img src="./project thumbnails/gestify_thumbnail.png" className="h-40 rounded-xl border-2" title="Click to view demo"/>
                </a>
              </div>
              
              <div>
                <h1 className="font-bold text-xl">Gestify</h1>
                <p className="py-2">An implementation of a real-time sign language detection webapp</p>
                {/* <p> <span className="text-blue-600">#python </span><span className="text-green-600"> #react</span> <span className="text-yellow-600"> #javascript</span> <span className="text-orange-600"> #tensorflow</span></p> */}
              </div>
            </div>
            {/* Project - 2 */}
            <div className="w-72 border-1 p-5 ml-16 rounded-xl shadow-[rgba(13,_38,_76,_0.19)_0px_9px_20px] mb-10 dark:bg-dPrimary sm:ml-0">
              <div className="flex justify-end cursor-pointer">
                {/* <a href="https://github.com/PaulJoshi/techkshetra22" target="_blank"><BsGithub className="animate-pulse text-xl" /></a> */}
                <a href="https://buildyourownresume.netlify.app/" target="_blank" className="flex items-center underline">View <IoOpen className="ml-1"/></a>
              </div>

              <div className="flex justify-center py-3 mb-5">
                <a href="https://www.techkshetra.tech/" target="_blank">
                  <img src="./project thumbnails/buildypurownresume.png" className="h-40 rounded-xl" title="Click to view demo"/>
                </a>
              </div>

              <div>
                <h1 className="font-bold text-xl">Resume Builder</h1>
                <p className="py-2">Dynamic and interactive resume builder for users to create professional resumes effortlessly.</p>
                {/* <p> <span className="text-blue-600">#react </span><span className="text-green-600"> #tailwindcss</span> <span className="text-yellow-600"> #redux</span> </p> */}
              </div>
            </div>
            {/* Project - 3 */}
            <div className="w-72 border-1 p-5 ml-16 rounded-xl shadow-[rgba(13,_38,_76,_0.19)_0px_9px_20px] mb-10 dark:bg-dPrimary sm:ml-0">
              <div className="flex justify-end cursor-pointer">
                {/* <a><BsGithub className="animate-pulse text-xl" /></a> */}
                <a href="https://github.com/peterjohnson1000/aws-email-newsletter-service" target="_blank" className="flex items-center underline">View <IoOpen className="ml-1"/></a>
              </div>
              
              <div className="flex justify-center py-3 mb-5 rounded-xl">
                <a href="https://github.com/peterjohnson1000/aws-email-newsletter-service" target="_blank">
                  <img src="./project thumbnails/email-newsletter-diagram.png" className="h-40 rounded-xl" title="Click to view demo"/>
                </a>
              </div>
            
              <div>
                <h1 className="font-bold text-xl">Email Newsletter Service</h1>
                <p className="py-2">Newsletter service where users can subscribe to a topic and the topic owner can send email to all subscribers.</p>
                {/* <p> <span className="text-blue-600">#aws </span> <span className="text-green-600"> #sns</span> <span className="text-yellow-600"> #lambda</span> <span className="text-blue-600">#ses</span> <span className="text-green-600"> #api</span></p> */}
              </div>
            </div>
        </div>

      </div>
    </div>
  );
};

export default Github;
